<script setup lang="ts">
import FilterSetting from '~/components/data-filters/FilterSetting.vue'
import { useMatchmakingDataStore } from '~/stores/matchmaking'
const matchmakingStore = useMatchmakingDataStore()
const filterSettings = computed(() => matchmakingStore.filterSettings)
</script>
<template>
  <div>
    <AppHeading title="Filtrera" type="h2" size="large" />
    <div class="flex flex-column flex-wrap sm:flex-row">
      <FilterSetting
        content-type="matchmaking"
        :setting="filterSettings.operator"
        class="mb-4 sm:mr-4 w-full md:max-w-10rem"
        :show-label="false"
      />
      <FilterSetting
        content-type="matchmaking"
        :setting="filterSettings.type"
        class="mb-4 sm:mr-4 w-full md:max-w-10rem"
        :show-label="false"
      />
      <FilterSetting
        content-type="matchmaking"
        :setting="filterSettings.fuelTypes"
        class="mb-4 sm:mr-4 w-full md:max-w-10rem"
        :show-label="false"
      />
      <FilterSetting
        content-type="matchmaking"
        :setting="filterSettings.vehicleType"
        class="mb-4 sm:mr-4 w-full md:max-w-10rem"
        :show-label="false"
      />
      <FilterSetting
        content-type="matchmaking"
        :setting="filterSettings.accessibility"
        class="mb-4 sm:mr-4 w-full md:max-w-10rem"
        :show-label="false"
      />
      <FilterSetting
        content-type="matchmaking"
        :setting="filterSettings.county"
        class="mb-4 sm:mr-4 w-full md:max-w-10rem"
        :show-label="false"
      />
    </div>
  </div>
</template>
